import { gql } from '@apollo/client'

export const CREATE_BUSINESS_SITE = gql`
  mutation CreateBusinessSite($input: CreateBusinessSiteInput!) {
    createBusinessSite(input: $input) {
      id
    }
  }
`
export const CREATE_BUSINESS_CLIENT = gql`
  mutation CreateBusinessClient($businessClient: CreateBusinessClientInput!) {
    createBusinessClient(input: $businessClient) {
      id
    }
  }
`
export const CHANGE_BUSINESS_CLIENT = gql`
  mutation ChangeBusinessClient($id: UUID!, $businessClient: ChangeBusinessClientInput!) {
    changeBusinessClient(id: $id, input: $businessClient)
  }
`

export const CREATE_BUSINESS_CLIENT_CONTACTS = gql`
  mutation CreateBusinessClientContacts($id: UUID!, $input: CreateBusinessClientContactsInput!) {
    createBusinessClientContacts(id: $id, input: $input)
  }
`

export const CHANGE_BUSINESS_CLIENT_CONTACTS = gql`
  mutation ChangeBusinessClientContacts($id: UUID!, $input: ChangeBusinessClientContactsInput!) {
    changeBusinessClientContacts(id: $id, input: $input)
  }
`

export const DELETE_BUSINESS_CLIENT_CONTACTS = gql`
  mutation DeleteBusinessClientContacts($id: UUID!, $input: DeleteBusinessClientContactsInput!) {
    deleteBusinessClientContacts(id: $id, input: $input)
  }
`

export const CHANGE_BUSINESS_CLIENT_KREDIT_SETTINGS = gql`
  mutation ChangeBusinessClientKreditSettings($input: ChangeBusinessClientKreditSettingsInput!) {
    changeBusinessClientKreditSettings(input: $input)
  }
`

export const PROCESS_BUSINESS_CLIENT_KREDITS_DISPERSION = gql`
  mutation ProcessBusinessClientKreditsDispersion($id: UUID!) {
    processBusinessClientKreditsDispersion(input: { id: $id })
  }
`
